import { createContext, useContext } from 'react';

/** How the enclosing layout wants its record pane shown. */
export interface PaneMode {
  /** No room beside the data: the pane renders as a Sheet. */
  narrow: boolean;
  /** Whether that Sheet is open. Ignored when not narrow. */
  open: boolean;
  onClose: () => void;
}

const PaneModeContext = createContext<PaneMode>({ narrow: false, open: false, onClose: () => {} });

export const PaneModeProvider = PaneModeContext.Provider;
export const usePaneMode = () => useContext(PaneModeContext);
